import React, { PureComponent } from "react";

import { Translate, I18n } from "react-redux-i18n";
import axios from "axios";
import { connect } from "react-redux";

import Accordion from "react-bootstrap/Accordion";
import ReactToPrint from "react-to-print";
import InfoModal from "../../utils/components/InfoModal";
import ReportDetail from "./ReportDetail";
import ArrowCardToggle from "../../utils/components/ArrowCardToggle";
import { roundToDecimals } from "../../utils/Utils";
import { setAlert } from "../../../actions/alertActions";
import moment from "moment";

import "../../../styles/components/insights/history/ChargerSessionSummary.scss";
import { ReactComponent as OPCIcon } from "../../../styles/images/opc_icon.svg";
import { ReactComponent as CEMEIcon } from "../../../styles/images/ceme_icon.svg";
import { ReactComponent as FeesIcon } from "../../../styles/images/fees_icon.svg";
import pencilSmall from "../../../styles/images/pencil_small.svg";
import download from "../../../styles/images/download.svg";
import clockIcon from "../../../styles/images/clock_darkgrey.svg";
import energyIcon from "../../../styles/images/energy_darkgrey.svg";
import AddKms from "./AddKms";

class ChargerSessionSummary extends PureComponent {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.componentRef = null;

    this.state = {
      isLoading: false,
      isLoadingKms: false,
      isOpenKms: false,
      kms: this.props.selectedItem?.evKms ? this.props.selectedItem.evKms.kms : 0,
      showKms: this.props.selectedItem?.evKms ? this.props.selectedItem.evKms.kms : 0,
    };

    this.handleInputValueChange = this.handleInputValueChange.bind(this);
    this.handleOnUpdateKms = this.handleOnUpdateKms.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedItem !== this.props.selectedItem) {
      if (this.props.selectedItem?.evKms?.kms) {
        this.setState({
          kms: this.props.selectedItem.evKms.kms,
          showKms: this.props.selectedItem.evKms.kms,
        });
      } else {
        this.setState({
          showKms: 0,
          kms: 0,
        });
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  getNetworkType(network) {
    if (network === null || typeof network === "undefined") {
      return "roaming";
    }

    const normalizedNetwork = String(network).toUpperCase().trim();

    if (normalizedNetwork === "EVIO") {
      return "internal";
    }

    if (normalizedNetwork === "MOBIE") {
      return "mobie";
    }

    if (
      normalizedNetwork === "GO.CHARGE" ||
      normalizedNetwork === "INTERNATIONAL NETWORK" ||
      normalizedNetwork === "KLC"
    ) {
      return "roaming";
    }

    return "roaming";
  }

  getPriceValue(priceObj) {
    if (!priceObj) {
      return 0;
    }

    if (!Number.isNaN(Number(priceObj.excl_vat))) {
      return Number(priceObj.excl_vat);
    }

    if (!Number.isNaN(Number(priceObj.incl_vat))) {
      return Number(priceObj.incl_vat);
    }

    if (!Number.isNaN(Number(priceObj.value))) {
      return Number(priceObj.value);
    }

    return 0;
  }

  formatMoney(value) {
    return `${roundToDecimals(Number.isNaN(Number(value)) ? 0 : Number(value), 2)} €`;
  }

  formatEnergy(totalPower) {
    if (Number.isNaN(Number(totalPower))) {
      return "-";
    }

    return Number(totalPower) < 1
      ? `${roundToDecimals(Number(totalPower) * 1000, 2)} Wh`
      : `${roundToDecimals(Number(totalPower), 2)} kWh`;
  }

  hasDataValue(value) {
    return value !== null && typeof value !== "undefined";
  }

  getSummaryRows(selectedItem, networkType) {
    if (networkType === "mobie") {
      const opcPriceDetail = selectedItem?.finalPrices?.opcPriceDetail;
      const opcTariffs = selectedItem?.tariffsDetails?.opc;
      const cemePriceDetail = selectedItem?.finalPrices?.cemePriceDetail;
      const cemeTariffs = selectedItem?.tariffsDetails?.ceme;
      const feesTariffs = selectedItem?.tariffsDetails?.fees;

      return [
        {
          key: "opc",
          icon: <OPCIcon />,
          title: "chargingSessionSummaryMobie_opc",
          total:
            this.getPriceValue(selectedItem?.finalPrices?.opcPrice) ||
            Number(selectedItem?.tariffsDetails?.opc?.total || 0),
          details: [
            {
              key: "activation",
              label: "chargingSessionSummaryMobie_activation",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.opcPriceDetail?.flatPrice) ||
                Number(selectedItem?.tariffsDetails?.opc?.activation || 0),
              hasData:
                this.hasDataValue(opcPriceDetail?.flatPrice) ||
                this.hasDataValue(opcTariffs?.activation),
            },
            {
              key: "energy",
              label: "chargingSessionSummaryMobie_energy",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.opcPriceDetail?.powerPrice) ||
                Number(selectedItem?.tariffsDetails?.opc?.energy || 0),
              hasData:
                this.hasDataValue(opcPriceDetail?.powerPrice) ||
                this.hasDataValue(opcTariffs?.energy),
            },
            {
              key: "time",
              label: "chargingSessionSummaryMobie_time",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.opcPriceDetail?.timePrice) ||
                Number(selectedItem?.tariffsDetails?.opc?.time || 0),
              hasData:
                this.hasDataValue(opcPriceDetail?.timePrice) ||
                this.hasDataValue(opcTariffs?.time),
            },
          ],
        },
        {
          key: "ceme",
          icon: <CEMEIcon />,
          title: "chargingSessionSummaryMobie_ceme",
          total:
            this.getPriceValue(selectedItem?.finalPrices?.cemePrice) ||
            Number(selectedItem?.tariffsDetails?.ceme?.total || 0),
          details: [
            {
              key: "activation",
              label: "chargingSessionSummaryMobie_activation",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.cemePriceDetail?.flatPrice) ||
                Number(selectedItem?.tariffsDetails?.ceme?.activation || 0),
              hasData:
                this.hasDataValue(cemePriceDetail?.flatPrice) ||
                this.hasDataValue(cemeTariffs?.activation),
            },
            {
              key: "energy",
              label: "chargingSessionSummaryMobie_energy",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.cemePriceDetail?.powerPrice) ||
                Number(selectedItem?.tariffsDetails?.ceme?.energy || 0),
              hasData:
                this.hasDataValue(cemePriceDetail?.powerPrice) ||
                this.hasDataValue(cemeTariffs?.energy),
            },
            {
              key: "time",
              label: "chargingSessionSummaryMobie_time",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.cemePriceDetail?.timePrice) ||
                Number(selectedItem?.tariffsDetails?.ceme?.time || 0),
              hasData:
                this.hasDataValue(cemePriceDetail?.timePrice) ||
                this.hasDataValue(cemeTariffs?.time),
            },
          ],
        },
        {
          key: "fees",
          icon: <FeesIcon />,
          title: "chargingSessionSummaryMobie_fees",
          total:
            this.getPriceValue(selectedItem?.finalPrices?.tarPrice) +
              this.getPriceValue(selectedItem?.finalPrices?.iecPrice) ||
            Number(selectedItem?.tariffsDetails?.fees?.total || 0) -
              Number(selectedItem?.tariffsDetails?.fees?.iva || 0),
          details: [
            {
              key: "iec",
              label: "chargingSessionSummaryMobie_iec",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.iecPrice) ||
                Number(selectedItem?.tariffsDetails?.fees?.iec || 0),
              hasData:
                this.hasDataValue(selectedItem?.finalPrices?.iecPrice) ||
                this.hasDataValue(feesTariffs?.iec),
            },
            {
              key: "tar",
              label: "chargingSessionSummaryMobie_tar",
              value:
                this.getPriceValue(selectedItem?.finalPrices?.tarPrice) ||
                Number(selectedItem?.tariffsDetails?.fees?.tar || 0),
              hasData:
                this.hasDataValue(selectedItem?.finalPrices?.tarPrice) ||
                this.hasDataValue(feesTariffs?.tar),
            },
          ],
        },
      ];
    }

    const details =
      networkType === "internal"
        ? selectedItem?.finalPrices?.opcPriceDetail
        : selectedItem?.finalPrices?.emspPriceDetail;

    return [
      {
        key: "activation",
        label: "chargingSessionSummaryMobie_activation",
        value:
          this.getPriceValue(details?.flatPrice) ||
          Number(selectedItem?.tariffsDetailsRoaming?.flatCost || 0),
      },
      {
        key: "energy",
        label: "chargingSessionSummaryMobie_energy",
        value:
          this.getPriceValue(details?.powerPrice) ||
          Number(selectedItem?.tariffsDetailsRoaming?.energyCost || 0),
      },
      {
        key: "time",
        label: "chargingSessionSummaryMobie_time",
        value:
          this.getPriceValue(details?.timePrice) ||
          Number(selectedItem?.tariffsDetailsRoaming?.timeCost || 0),
      },
    ];
  }

  handleInputValueChange(e) {
    const value = e.target.value;

    if (!isNaN(value) && value.length <= 8 && Number(value) <= 100000000) {
      this.setState({
        kms: value,
      });
    }
  }

  handleOnUpdateKms() {
    const packet = {
      evID: this.props.selectedItem.evId,
      kms: Number(this.state.kms),
      chargerType: this.props.selectedItem.chargerType,
      sessionID: this.props.selectedItem.sessionId,
      userID: this.props.accountData.id,
    };

    if (this.state.kms > 0) {
      if (!this.state.showKms) {
        this.setState({
          isLoadingKms: true,
        });

        axios
          .post("/api/ev/session/kms", packet)
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                isOpenKms: false,
                isLoadingKms: false,
                showKms: res.data.chargingSession.evKms.kms,
              });
              this.props.setAlert(I18n.t(res.data?.message?.message), "primary");
            }
          })
          .catch((err) => {
            this.setState({
              isLoadingKms: false,
            });
            if (err.response.status === 409) {
              const updateMessage = I18n.t("insertKm_messageErrorKmAndDateUpdateTrue");
              const updateFinalMessage = updateMessage
                .replace("XX", err.response.data.lastEvKms.kms)
                .replaceAll(
                  "YY",
                  moment(err.response.data.lastEvKms.kmsDate).format("DD-MM-YYYY"),
                );

              this.props.setAlert(updateFinalMessage, "danger");
            } else {
              this.props.setAlert(I18n.t(err.response.data.message), "danger");
            }
          });
      } else {
        axios
          .patch("/api/ev/session/kms", packet)
          .then((res) => {
            if (res.status === 200) {
              this.setState({
                isOpenKms: false,
                isLoadingKms: false,
                showKms: res.data.chargingSession.evKms.kms,
              });
              this.props.setAlert(res.data?.message?.message, "primary");
            }
          })
          .catch((err) => {
            this.setState({
              isLoadingKms: false,
            });
            if (err.response.status === 409) {
              const updateMessage = I18n.t("insertKm_messageErrorKmAndDateUpdateTrue");
              const updateFinalMessage = updateMessage
                .replace("XX", err.response.data.lastEvKms.kms)
                .replaceAll(
                  "YY",
                  moment(err.response.data.lastEvKms.kmsDate).format("DD-MM-YYYY"),
                );

              this.props.setAlert(updateFinalMessage, "danger");
            } else {
              this.props.setAlert(I18n.t(err.response.data.message), "danger");
            }
          });
        this.setState({
          isLoadingKms: true,
        });
      }
    } else {
      this.props.setAlert(I18n.t("insertKms_messageErrorValue"), "danger");
    }
  }

  renderKmsRow(selectedItem) {
    return (
      this.props.userPackage?.mileageEntryEnabled &&
      (selectedItem?.acceptKMs || (!selectedItem?.acceptKMs && this.state.showKms !== 0)) && (
        <button
          className="update-kms-btn total-value"
          onClick={() =>
            this.setState({
              isOpenKms: selectedItem?.acceptKMs ? true : false,
            })
          }
        >
          <p>
            <span>
              <Translate value="evs_kms" /> {moment(selectedItem?.startDate).format("DD-MM-YYYY")}
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <div>
              <b>{this.state.showKms ? `${Math.round(this.state.showKms)} km` : "-"}</b>
            </div>
            {selectedItem?.acceptKMs && (
              <div style={{ padding: "0.5rem", paddingRight: "1.25rem" }}>
                <img src={pencilSmall} className="icon" alt="" />
              </div>
            )}
          </div>
        </button>
      )
    );
  }

  render() {
    const selectedItem = this.props.selectedItem || {};
    const networkType = this.getNetworkType(selectedItem?.network);
    const rows = this.getSummaryRows(selectedItem, networkType);
    const totalExclVat = Number(selectedItem?.totalPrice?.excl_vat || 0);
    const totalInclVat = Number(selectedItem?.totalPrice?.incl_vat || 0);
    const vatValue =
      Number(selectedItem?.finalPrices?.vatPrice?.value) || totalInclVat - totalExclVat;

    return (
      <InfoModal
        title={<Translate value="chargerSessionSummary_title" />}
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <div id="chargerSessionSummary">

          <div className="top-row">
            <div className="highlight-container muted">
              <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <img src={clockIcon} alt="" width={18} height={18} />
                <Translate value="chargerSessionSummary_totalChargingTime" />
              </p>
              <p>{selectedItem.totalTimeInMin || "0s"}</p>
            </div>
            <div className="highlight-container muted">
              <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <img src={energyIcon} alt="" width={18} height={18} />
                <Translate value="chargerSessionSummary_energySupplied" />
              </p>
              <p>{this.formatEnergy(selectedItem.totalPower)}</p>
            </div>
          </div>

          {this.renderKmsRow(selectedItem)}

          {networkType === "mobie" ? (
            <Accordion>
              {rows.map((row, index) => {
                const detailsToDisplay = row.details.filter((detail) => detail.hasData);
                const showRowArrow = detailsToDisplay.length > 0;

                return (
                  <div className="accordion-item" key={row.key}>
                    <ArrowCardToggle eventKey={`${index}`} showArr={showRowArrow}>
                      <div className="card-header-container">
                        {row.icon}
                        <p>
                          <Translate value={row.title} />
                        </p>
                        <p className="total-price">{this.formatMoney(row.total)}</p>
                      </div>
                    </ArrowCardToggle>
                    {showRowArrow && (
                      <Accordion.Collapse eventKey={`${index}`}>
                        <div className="price-rows-container">
                          {detailsToDisplay.map((detail) => (
                            <div className="price-row" key={detail.key}>
                              <p>
                                <Translate value={detail.label} />
                              </p>
                              <p>{this.formatMoney(detail.value)}</p>
                            </div>
                          ))}
                        </div>
                      </Accordion.Collapse>
                    )}
                  </div>
                );
              })}
            </Accordion>
          ) : (
            <Accordion id="newSummary">
              {rows.map((row, index) => (
                <div className="accordion-item" key={row.key}>
                  <ArrowCardToggle eventKey={`${index}`} showArr={false}>
                    <div className="card-header-container">
                      <OPCIcon />
                      <p>
                        <span>
                          <Translate value={row.label} />
                        </span>
                      </p>
                      <p className="total-price">
                        <b>{this.formatMoney(row.value)}</b>
                      </p>
                    </div>
                  </ArrowCardToggle>
                </div>
              ))}
            </Accordion>
          )}

          <p className="total-value">
            <span>
              <Translate value="chargerSessionSummary_total" />:
            </span>
            <b>{this.formatMoney(totalExclVat)}</b>
          </p>
          <p className="total-value">
            <span><Translate value="history_vat"/>:</span>
            <b>{this.formatMoney(vatValue)}</b>
          </p>
          <p className="total-value">
            <span>
              <Translate value="chargerSessionSummary_total" /> <Translate value="history_withVat"/>:
            </span>
            <b>{this.formatMoney(totalInclVat)}</b>
          </p>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
            <ReactToPrint
              content={() => this.componentRef}
              onBeforePrint={() => this.setState({ isLoading: false })}
              trigger={() => (
                <button type="button" className="link export-btn">
                  <img alt="evio_img7" src={download} />
                  <Translate value="reports_export" />
                </button>
              )}
            />
          </div>

          <div style={{ display: "none" }}>
            <ReportDetail
              data={selectedItem}
              withVat={this.props.withVat}
              accountData={this.props.accountData}
              brand={this.props.brand}
              ref={(el) => (this.componentRef = el)}
              type={this.props.type}
            />
          </div>
          {this.state.isOpenKms && (
            <AddKms
              show={this.state.isOpenKms}
              onHide={() => this.setState({ isOpenKms: false })}
              value={this.state.kms}
              handleInputValueChange={this.handleInputValueChange}
              handleOnUpdateKms={this.handleOnUpdateKms}
              isLoadingKms={this.state.isLoadingKms}
              evKms={selectedItem.evKms}
              showKms={this.state.showKms}
            />
          )}
        </div>
      </InfoModal>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  userPackage: state.account.accountData.userPackage,
});

export default connect(mapStateToProps, { setAlert })(ChargerSessionSummary);
